import 'styles/styles.css';

export function Button ({ onClick }) {
    return (
        <button className='Button' onClick={onClick}>Load More</button>
    )};